import {MODALS_CLOSE, MODALS_WINDOW_RESIZE} from "./ModalsConstants";

export const closeModals = () => (dispatch) => {
  dispatch({
    type: MODALS_CLOSE
  })
};

export const modalWindowResize = (sizes) => (dispatch) => {
  dispatch({
    type: MODALS_WINDOW_RESIZE, action: sizes
  })
};




// WEBPACK FOOTER //
// ./src/common/modals/ModalsActions.js